import React from 'react';
import { useIsMobile } from '@/hooks';
import DoughnutChart from '../DoughnutChart/DoughnutChart';
import styles from './DoughnutChartWithDetail.module.scss';

interface DoughnutChartWithDetailProps {
  label: string;
  detail: string;
  completion: number;
  color: string;
  strokeColor?: string;
}

const DoughnutChartWithDetail: React.FC<DoughnutChartWithDetailProps> = ({
  label,
  detail,
  completion,
  color,
  strokeColor,
}) => {
  const isMobile = useIsMobile();
  return (
    <div className={styles.container}>
      {' '}
      {isMobile ? null : (
        <DoughnutChart
          strokeColor={strokeColor}
          completion={completion}
          color={color}
        />
      )}
      <span className={styles.label}>{label}</span>
      <span className={styles.detail}>{detail}</span>
    </div>
  );
};

export default DoughnutChartWithDetail;
